import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  IconCircleMinus,
  IconCirclePlus,
  IconBlock,
  IconVerified,
  IconTransfer,
} from '@tokenyico/tokeny-ui';

const TransactionTypeCell = ({ type }) => {
  const { t } = useTranslation();
  if (['transfer'].includes(type))
    return (
      <div className="_flex-row _text:sm" style={{ alignItems: 'center' }}>
        <IconTransfer size={15} className="_m:right(2)" />
        <span>{t('shared.transfer')}</span>
      </div>
    );
  if (['mint'].includes(type))
    return (
      <div className="_flex-row _text:sm" style={{ alignItems: 'center' }}>
        <IconCirclePlus size={15} className="_m:right(2)" />
        <span>{t('shared.mint')}</span>
      </div>
    );
  if (['burn'].includes(type))
    return (
      <div className="_flex-row _text:sm" style={{ alignItems: 'center' }}>
        <IconCircleMinus size={15} className="_m:right(2)" />
        <span>{t('shared.burn')}</span>
      </div>
    );
  if (['block'].includes(type))
    return (
      <div className="_flex-row _text:sm" style={{ alignItems: 'center' }}>
        <IconBlock size={15} className="_m:right(2)" />
        <span>{t('shared.block')}</span>
      </div>
    );
  if (['unblock'].includes(type))
    return (
      <div className="_flex-row _text:sm" style={{ alignItems: 'center' }}>
        <IconVerified size={15} className="_m:right(2)" />
        <span>{t('shared.unblock')}</span>
      </div>
    );
  else
    return (
      <div className="_flex-row _text:sm" style={{ alignItems: 'center' }}>
        <span>{type}</span>
      </div>
    );
};

export default TransactionTypeCell;
